/**
 * API error codes that need handling in the UI rather than just translation.
 * Codes arrive as the rejected action's `error.message` and are translated
 * through the `apiError` i18n namespace.
 */
const API_ERROR_CODES = {
  /**
   * Returned when a user has simply never been screened. It is an expected
   * empty state, not a failure, so screens represent it inline instead of
   * raising a red error banner.
   */
  SCREEN_NOT_FOUND: 'SCREEN_NOT_FOUND',
};

export default API_ERROR_CODES;
